import * as React from 'react';

const t={prefix:Math.round(1e10*Math.random()),current:0},n=/*#__PURE__*/React.createContext(t);function useId(r){const o=React.useContext(n);return Boolean(null===globalThis||void 0===globalThis?void 0:globalThis.document)||o!==t||console.warn("When server rendering, you must wrap your application in an <IdProvider> to ensure consistent ids are generated between the client and server."),React.useMemo((()=>r||`radix-id-${o.prefix}-${++o.current}`),[r])}

export { useId };
